/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { SubEvaluationResultDimGrades } from './subEvaluationResultDimGrades';

/**
 * Per-question result from oral exam autograding.
 */
export interface SubEvaluationResult {
  id: string;
  dimGrades: SubEvaluationResultDimGrades;
  justification: string;
}
